// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33aou","rootMobile":"styles_rootMobile__3CWQ0"};